export * from './hots.component'